import { useEffect, useState } from 'react';

export const STUCK_LOADING_TIMEOUT_MS = 15_000;

/** Returns true once the caller has been loading for `timeoutMs` without unmounting. */
export function useStuckLoadingTimeout(timeoutMs: number = STUCK_LOADING_TIMEOUT_MS): boolean {
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setStuck(true), timeoutMs);
    return () => clearTimeout(timer);
  }, [timeoutMs]);

  return stuck;
}
